import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadMergeTestIdAction,
    ILoadMergeTestIdSuccessAction,
    ILoadMergeTestIdErrorAction
} from '../actions/service/merge/load-merge-test-id';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type MergeTestIdAction
    = ILoadMergeTestIdAction
    | ILoadMergeTestIdSuccessAction
    | ILoadMergeTestIdErrorAction;

const init = (state: ITicketsState, action: MergeTestIdAction) => ({
    ...state,
    mergeTestIdRequest: {
        ...initialState.mergeTestIdRequest,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: MergeTestIdAction) => ({
    ...state,
    mergeTestIdRequest: {
        ...initialState.mergeTestIdRequest,
        status: action.status,
        mergeTestId: (action as ILoadMergeTestIdSuccessAction).mergeTestId,
        plannedOutageId: (action as ILoadMergeTestIdSuccessAction).plannedOutageId,
    }
})

const failure = (state: ITicketsState, action: MergeTestIdAction) => ({
    ...state,
    mergeTestIdRequest: {
        ...initialState.mergeTestIdRequest,
        status: action.status,
        error: (action as ILoadMergeTestIdErrorAction).error
    }
});

export const mergeTestIdReducer = createAsyncReducer(initialState, init, success, failure);
